import { PointerSensor } from "@dnd-kit/core";

const IGNORED_DRAG_TARGET = "a, button, input, select, textarea, [data-no-dnd]";

export function isCollegeRankDragIgnored(target: EventTarget | null): boolean {
    if (!(target instanceof Element)) {
        return true;
    }
    return Boolean(target.closest(IGNORED_DRAG_TARGET));
}

export class CollegeRankPointerSensor extends PointerSensor {
    static activators = [
        {
            eventName: "onPointerDown" as const,
            handler: (
                event: { nativeEvent: PointerEvent },
                { onActivation }: { onActivation?: (args: { event: PointerEvent }) => void },
            ) => {
                const nativeEvent = event.nativeEvent;
                if (!nativeEvent.isPrimary || nativeEvent.button !== 0) {
                    return false;
                }
                if (isCollegeRankDragIgnored(nativeEvent.target)) {
                    return false;
                }
                onActivation?.({ event: nativeEvent });
                return true;
            },
        },
    ];
}
